<template>
    <div class="recommend">
        <scroll ref="scroll" class="recommend-content" :data="columnStore" :pullUpLoad="pullup" @pullingUp="columnListMore" :beforeScroll="beforeScroll"  @pullingDown="columnListRes" :pullDownRefresh="pulldown">
            <div>
                <div class='importantNews_default'>
                    <div class='contain' v-if="isCloseSkeletonScreen">
                        <ul class='contain_context'>
                            <import-news-item v-for="item in columnStore" :key="item.id" :itemData="item" @handleClickIsStretch="handleClickIsStretch"></import-news-item>
                        </ul>
                    </div>
                    <div v-if="!isCloseSkeletonScreen">
                        <SkeletonScreen :data="5"/>
                    </div>
                </div>
                <read-more v-if="!hasMore&&!listLoading"></read-more>
            </div>
        </scroll>
    </div>
</template>
<script>
import Scroll from '@/base/scroll/pulldown'
import HomeApi from '@/api/importantNews/';
import importNewsItem from '@/components/importNewsItem/';
import readMore from '@/components/readMore/';

import stock_pool from '@/assets/images/stock_pool2x.png'
import mohu from '@/assets/images/mohu@2x.png'
// import SkeletonScreen from '@/components/SkeletonScreen'
export default {
    name: 'INewsList',
    components: {
        Scroll,
        readMore,
        importNewsItem,
        // SkeletonScreen
    },
    data() {
        return {
            pullup: true,
            topLoading: false,
            beforeScroll: true,
            hasMore: false,
            listLoading: true,
            pulldown: true,
            before: '',
            columnStore: [],
            page: 1,
            stock_pool,
            mohu,
            isCloseSkeletonScreen: false,
            randomStr: Math.random().toString(36).slice(-4)

        };
    },
    created() {
        this.getColumnList()
    },

    methods: {
        columnListMore() {
            if (!this.hasMore) return
            this.before = this.columnStore[this.columnStore.length - 1].rec_time;
            this.getColumnList()
        },
        async getColumnList() {
            this.hasMore = false
            let data = await HomeApi.getImportantNewsList2(this.before);
            // 分享
            this.$share(data.share)
            this.isCloseSkeletonScreen = true;
            if (!this.before) {
                this.topLoading = false
                this.columnStore = data.data
            } else {
                this.columnStore = this.columnStore.concat(data.data)
            }
            this.hasMore = true
            // this.pullup = false
            // if (this.page < 2) {
            // } else {
            //     this.hasMore = false
            //     this.listLoading = false
            // }
        },
        handleClickIsStretch(){
            setTimeout(() => {
                this.$refs.scroll.refresh()
            }, 20);
        },
        columnListRes(){
            this.topLoading = true
            this.isCloseSkeletonScreen = false
            this.before = ''
            this.getColumnList(true)
        }

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.recommend {
    position: fixed;
    overflow: auto;
    top: 48px;
    width: 100%;
    padding-bottom: 50px;
    bottom: 0;
    background-color: #F0F0F0;
}

.recommend-content {
    height: 100%;
    overflow: hidden;
}

.importantNews_default {
    padding-top: 10px;
    width: 100%;
    background-color: #F0F0F0;
    height: 100%;

    .loading2 {
        position: absolute;
        padding-left: 142px;
        bottom: 46px;
        vertical-align: middle;
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #939393;
        background-color: #F0F0F0;
        width: 100%;

        img {
            width: 20px;
            height: 20px;
            margin-right: 9px;
        }
    }
}

.main {
    width: 100%;
    background-color: #F0F0F0;
    height: 100%;

    .loading {
        position: absolute;
        display: inline;
        top: 60px;
        left: 142px;
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #939393;
        vertical-align: middle;

        img {
            width: 20px;
            height: 20px;
            margin-right: 9px;
        }
    }
}

.contain {
    padding: 10px 14px 0 14px;
    background-color: #FFFFFF;

    ul {}
}

.noAction {
    width: 100%;
    font-size: 16px;
    text-align: left;
    overflow: hidden;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    //最多3行显示
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-height: 22px;
}

.active {
    color: #C7000A;
}

.multimedia {
    height: 100px;
    margin-top: 7px;
    margin-bottom: 7px;

    div {
        margin-right: 10px;
    }

    >img {
        margin-right: 10px;
    }
}

.stock_pool {
    margin: 11px 0 13px 0;
    width: 100%;
    height: 32px;
    background-color: #FBF7F3;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .stock_pool_head {
        font-size: 12px;
        color: #5B5B5B;
        width: 96px;
        height: 14px;
        letter-spacing: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 4px 0 6px !important;

        >img {
            width: 13px;
            height: 14px;
        }

        span {
            height: 14px;
            line-height: 14px;
        }
    }

    .stock_pool_foot {
        width: 60px;
        height: 14px;
        font-size: 12px;
        text-align: right;
        line-height: 14px;
        display: inline-block;
        color: #5B5B5B;
        margin-right: 9px;
    }

    >div {
        width: 200px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        >img {
            width: 100px;
            height: 100%;
        }

        @media screen and (max-width: 410px) {
            .img_two {
                display: none;
            }
        }
    }
}


//首页的部分样式
.home_importNewsFoot {
    width: 100%;
    margin-top: 14px;
    position: relative;
    margin-bottom: 10px;

    a {
        color: #1C88D0;
        font-size: 13px;
        width: 96px;
        display: inline-block;
    }

    p {
        margin-bottom: 5px;
        margin-top: 5px;
        color: #898989;
        font-family: PingFang-SC-Medium;
        font-weight: SC-Medium;
        font-size: 12px;
        position: absolute;
        right: 0;
        display: inline-block;

        span {
            margin-right: 13px;
        }

        img {
            margin-right: 1px;
            width: 14px;
            height: 12px;
            display: inline-block;
        }
    }
}

.i_type {
    font-family: PingFang-SC-Bold;
    display: inline-block;
    font-weight: bold;
    margin-right: 5px;
    color: #C7000A;
}
</style>